'use client'

import { useState } from 'react'
import { useRouter } from 'next/navigation'
import HostingProgressModal from '@/components/HostingProgressModal'

export default function BuyButton({ 
  itemId, 
  price, 
  userBalance, 
  isHosting = false, 
  itemName = 'Hosting Node' 
}: { 
  itemId: string, 
  price: number, 
  userBalance: number, 
  isHosting?: boolean, 
  itemName?: string 
}) {
  const [isClaiming, setIsClaiming] = useState(false)
  const [loading, setLoading] = useState(false)
  const router = useRouter()

  const hasEnough = userBalance >= price

  const handleBuy = async () => {
    if (!hasEnough) return alert('Insufficient points!')

    if (isHosting) {
      setIsClaiming(true) // Triggers the progress modal & passes itemId correctly
      return
    }

    // Standard purchase for cosmetics / badges / etc.
    setLoading(true)
    try {
      const res = await fetch('/api/store/buy', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ itemId })
      })
      const data = await res.json()
      if (data.success) {
        router.refresh()
      } else {
        alert(data.error || 'Failed to purchase item.')
      }
    } catch (err) {
      alert('Network error.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <button
        onClick={handleBuy}
        disabled={!hasEnough || loading}
        className="px-4 py-2 bg-indigo-600 hover:bg-indigo-500 text-white font-bold text-xs rounded-xl transition-colors shadow-lg shadow-indigo-500/20 disabled:opacity-50 cursor-pointer"
      >
        {loading ? 'Processing...' : isHosting ? 'Claim Node' : 'Buy Item'}
      </button>

      {isHosting && (
        <HostingProgressModal
          isOpen={isClaiming}
          itemId={itemId}
          packageName={itemName}
          onClose={() => {
            setIsClaiming(false)
            router.refresh()
          }}
        />
      )}
    </>
  )
}